(function () {
    'use strict';
    'ngInject';

    angular.module('app.ctrls').controller('ForgotPasswordCtrl', forgotPasswordCtrl);

    function forgotPasswordCtrl($rootScope, $scope, $location, UsersAPIService, blockUI, $mdDialog) {
        $rootScope.showHeader = false;
        $scope.email = '';

        $scope.sendResetEmail = function () {
            blockUI.start();
            UsersAPIService.sendPasswordResetEmail($scope.email)
                .then(() => {
                    blockUI.stop();

                    $mdDialog
                        .show(
                            $mdDialog
                                .alert()
                                .parent(document.body)
                                .clickOutsideToClose(true)
                                .title('Password reset')
                                .textContent('A link for password reset was sent to your email')
                                .ok('OK!')
                        )
                        .finally(() => {
                            $location.path('/signin');
                        });
                })
                .catch((err) => {
                    blockUI.stop();
                    $mdDialog.show(
                        $mdDialog
                            .alert()
                            .parent(document.body)
                            .clickOutsideToClose(true)
                            .title('User creation')
                            .textContent(err.data.Message)
                            .ok('OK!')
                    );
                });
        };
    }
})();
